"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translate_1 = require("./translate");
exports.Translate = translate_1.default;
exports.translate = translate_1.translate;
var translator_context_1 = require("./translator-context");
exports.TranslatorContext = translator_context_1.default;
//# sourceMappingURL=index.js.map